// Currency module. Amounts are stored in USD (reference); we convert for display only.
// Rates = units per 1 USD. Static & editable — replace with a live FX feed later if needed.
export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar', rate: 1 },
  { code: 'EUR', symbol: '€', name: 'Euro', rate: 0.92 },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', rate: 157 },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', rate: 5.4 },
  { code: 'MXN', symbol: 'Mex$', name: 'Mexican Peso', rate: 18 },
  { code: 'COP', symbol: 'COL$', name: 'Colombian Peso', rate: 4000 },
  { code: 'PEN', symbol: 'S/', name: 'Peruvian Sol', rate: 3.75 },
  { code: 'ARS', symbol: 'AR$', name: 'Argentine Peso', rate: 950 },
  { code: 'MAD', symbol: 'MAD', name: 'Moroccan Dirham', rate: 9.9 },
  { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc', rate: 605 },
];

export const CUR_BY_CODE = CURRENCIES.reduce((a, c) => { a[c.code] = c; return a; }, {});
export const SUPPORTED_CURRENCY_CODES = CURRENCIES.map((c) => c.code);

// Institution → display currency (matches the member's country / operating currency).
const INSTITUTION_CURRENCY = {
  inst_afd: 'EUR',
  inst_cdp: 'EUR',
  inst_cdg: 'MAD',
  inst_boad: 'XOF',
  inst_bndes: 'BRL',
  inst_jica: 'JPY',
  inst_bancoldex: 'COP',
  inst_nafin: 'MXN',
  inst_cofide: 'PEN',
  inst_bice: 'ARS',
  // CAF / BCIE (multilateral), and all other members default to USD
};

export const currencyForInstitution = (institutionId) => INSTITUTION_CURRENCY[institutionId] || 'USD';

const LOCALE = { en: 'en-US', fr: 'fr-FR', es: 'es-ES', pt: 'pt-BR', it: 'it-IT', ja: 'ja-JP' };

export function convert(valueUSD, currency = 'USD') {
  const c = CUR_BY_CODE[currency] || CUR_BY_CODE.USD;
  return (Number(valueUSD) || 0) * c.rate;
}

// Compact currency formatting (B / M) for headline figures.
export function formatMoney(valueUSD, currency = 'USD', lang = 'en') {
  const c = CUR_BY_CODE[currency] || CUR_BY_CODE.USD;
  const v = convert(valueUSD, currency);
  const abs = Math.abs(v);
  const sym = c.symbol;
  const loc = LOCALE[lang] || 'en-US';
  if (abs >= 1e9) return `${sym}${(v / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${sym}${(v / 1e6).toFixed(v >= 1e7 ? 0 : 1)}M`;
  return `${sym}${Math.round(v).toLocaleString(loc)}`;
}
